import React from "react";
import { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    Filler,
} from "chart.js";
import { Doughnut, Line } from "react-chartjs-2";
import { Container, Typography, Box, Button } from "@mui/material";
import Loading from "./components/Loading";
import Skeleton from "@mui/material/Skeleton";
import { useNavigate } from "react-router-dom";
import UpdateIcon from "@mui/icons-material/Update";
import MessageModal from "./components/MessageModal";
import { CategoryScale } from "chart.js";
import { DataGrid } from "@mui/x-data-grid";
import { darken } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import { URL, origin } from "./config";
import { Helmet } from "react-helmet-async";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    Filler
);
ChartJS.register(ArcElement, Tooltip, Legend, Title);

export default function Donut() {
    const theme = useTheme();

    //test data for donut chart

    // const test = {
    //     labels: ['Swyftx', 'Commbank', 'SelfWealth'],
    //     datasets: [
    //       {
    //         // label: 'Value AUD',
    //         data: [12, 19, 3],
    //         backgroundColor: [
    //           'rgba(255, 99, 132, 0.2)',
    //           'rgba(54, 162, 235, 0.2)',
    //           'rgba(255, 206, 86, 0.2)',
    //           'rgba(75, 192, 192, 0.2)',
    //           'rgba(153, 102, 255, 0.2)',
    //           'rgba(255, 159, 64, 0.2)',
    //         ],
    //         borderColor: [
    //           'rgba(255, 99, 132, 1)',
    //           'rgba(54, 162, 235, 1)',
    //           'rgba(255, 206, 86, 1)',
    //           'rgba(75, 192, 192, 1)',
    //           'rgba(153, 102, 255, 1)',
    //           'rgba(255, 159, 64, 1)',
    //         ],
    //         borderWidth: 1,
    //       },
    //     ],
    //   };

    const formatter = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "AUD",
    });
    const lineOptions = {
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                labels: {
                    color: theme.palette.primary.contrastText,
                },
            },
            title: {
                display: true,
                text: "Total value over time",
                color: theme.palette.primary.contrastText,
            },
        },
        scales: {
            y: {
                grid: {
                    color: theme.palette.primary.contrastText,
                },
                ticks: {
                    color: theme.palette.primary.contrastText,
                },
            },
            x: {
                ticks: {
                    color: theme.palette.primary.contrastText,
                },
            },
        },
    };

    const dougnutOptions = {
        plugins: {
            title: {
                display: true,
                text: "Wealth breakdown",
                color: theme.palette.primary.contrastText,
            },
            legend: {
                display: true,
                labels: {
                    color: theme.palette.primary.contrastText,
                },
            },
        },
    };
    const [data, setData] = useState({});
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);
    const [total, setTotal] = useState("");
    const [lastUpdated, setlastUpdated] = useState("");
    const navigate = useNavigate();
    const [lineData, setLineData] = useState({});
    const [gridTotals, setGridtotals] = useState([]);
    const [render, setRender] = useState(0);

    console.log(total);
    const gridHeaders = [
        { field: "platform", headerName: "Platform", width: 150 },
        { field: "value", headerName: "Value (AUD)", width: 150 },
    ];

    function updateData() {
        setLoading(true);
        fetch(`${URL}/update/`, {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
        })
            .then((response) => {
                if (response.ok === false) {
                    navigate(`/${response.status}`);
                    setError(response.statusText);
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
                setRender((x) => x + 1);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
            });
    }

    const closeAlert = () => {
        setError("");
    };

    function fetchData() {
        setLoading(true);
        fetch(`${URL}/fetch/`, {
            method: "GET",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
        })
            .then((response) => {
                if (response.ok === false) {
                    navigate(`/${response.status}`);
                    setError(response.statusText);
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then((data) => {
                console.log(data);
                const formattedData = createData(data);
                setData(formattedData);
                setLineData(createLineData(data));
                console.log(data);
                console.log(formattedData);
                setTotal(formatter.format(data.total));
                setLoading(false);
                setlastUpdated(
                    new Date(data.lastUpdatedOn).toLocaleString("en-US", {
                        weekday: "long",
                        month: "long",
                        day: "numeric",
                        hour: "numeric",
                        minute: "numeric",
                        hour12: true, // 12-hour time format
                    })
                );
            })
            .catch((err) => {
                console.error(err);
            });
    }

    useEffect(() => {
        setTotal("");
        fetchData();
    }, [render]);

    function createData(data) {
        const totalValues = {};
        for (const service in data.services) {
            totalValues[service] = data.services[service].data.totalValue;
        }

        console.log(totalValues);
        const arr = Object.entries(totalValues);
        console.log(arr);
        setGridtotals(
            arr.map((x) => {
                if (1) {
                    console.log(x[1]);
                    const a = {};
                    a["id"] = x[0];
                    a["platform"] = x[0];
                    x[1]
                        ? (a["value"] = formatter.format(x[1]))
                        : (a["value"] = "click to link service");
                    console.log(a);
                    return a;
                }
            })
        );
        const graph = {
            labels: Object.keys(totalValues),
            datasets: [
                {
                    label: "Value AUD",
                    data: Object.values(totalValues),
                    backgroundColor: [
                        "rgba(240, 205, 10)",
                        "rgba(10, 240, 101)",
                        "rgba(10, 138, 240)",
                    ],
                    borderColor: [
                        "rgba(240, 205, 10)",
                        "rgba(10, 240, 101)",
                        "rgba(10, 138, 240)",
                    ],
                    borderWidth: 1,
                },
            ],
        };
        return graph;
    }

    function createLineData(data) {
        const newTotals = data.totalHistory.map((x) => {
            // this is to make it backwards compatible with previous data structure. Will not be needed in final build.
            if (x["value"]) {
                const a = {};
                a["total"] = x["value"];
                a["timestamp"] = x["timestamp"];
                return a;
            } else {
                return x;
            }
        });
        console.log(newTotals);
        const history = newTotals.filter((a, b) => {
            return a.total != null;
        });
        const result = history.reduce((a, b) => {
            a[b.timestamp.slice(0, 10)] = b.total;
            return a;
        }, {});
        const graph = {
            labels: Object.keys(result),
            datasets: [
                {
                    label: "Total value history",
                    data: Object.values(result),
                    backgroundColor: "rgba(42, 194, 245, 0.2)",
                    borderColor: "rgba(42, 194, 245)",
                    color: "white",
                    fill: true,
                },
            ],
        };
        return graph;
    }

    function handleGridClick(params) {
        params.row.value === "click to link service"
            ? navigate(`/link/${params.row.platform}`)
            : navigate(`${[params.row.platform]}`);
    }

    return (
        <>
            <Helmet>
                <title>WealthWatch | dashboard</title>
            </Helmet>
            <Container
                maxWidth="xl"
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(12, 1fr)",
                    gridAutoRows: "100px",
                    gap: "20px",
                    "@media (max-width: 75em)": {
                        flexDirection: "column",
                        display: "flex",
                    },
                }}
            >
                <>
                    <Box
                        gridColumn="span 5"
                        gridRow="span 6"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 1,
                            boxShadow: 14,
                            outline: `1px solid ${theme.palette.primary.main}`,
                            transition: "outline 1s ease",
                            "&:hover": {
                                outline: `1px solid ${theme.palette.primary.contrastText}`,
                            },
                            marginTop: 2,
                        }}
                    >
                        <Container sx={{ width: "90%", height: "90%" }}>
                            {loading ? (
                                <Loading
                                    color="secondary"
                                    size={70}
                                    thickness={2}
                                />
                            ) : (
                                <Doughnut
                                    data={data}
                                    options={dougnutOptions}
                                ></Doughnut>
                            )}
                        </Container>
                        <Typography variant="h5" color="green">
                            {total}{" "}
                        </Typography>
                        <Typography
                            textAlign="center"
                            color="grey"
                            width="90%"
                        >{`last updated on: ${lastUpdated}`}</Typography>
                        <Button
                            variant="contained"
                            startIcon={<UpdateIcon />}
                            sx={{
                                m: 1,
                                backgroundColor: "primary.main",
                                color: "primary.contrastText",
                            }}
                            onClick={updateData}
                        >
                            Update
                        </Button>
                    </Box>
                    <Box
                        sx={{
                            marginTop: 2,
                            gridColumn: "span 6",
                            gridRow: "span 3",
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 1,
                            outline: `1px solid ${theme.palette.primary.main}`,
                            transition: "outline 1s ease",
                            overflow: "auto",
                            boxShadow: 14,
                            "&:hover": {
                                outline: `1px solid ${theme.palette.primary.contrastText}`,
                            },
                            "@media (max-width: 75em)": {
                                minHeight: "40vh",
                            },
                        }}
                    >
                        <DataGrid
                            sx={{
                                border: "none",
                                color: theme.palette.primary.dark,
                                "& .selfwealth": {
                                    backgroundColor: "rgba(10, 240, 101)",
                                    "&:hover": {
                                        backgroundColor: darken(
                                            "rgba(10, 240, 101)",
                                            0.3
                                        ),
                                    },
                                    cursor: "pointer",
                                },
                                "& .swyftx": {
                                    backgroundColor: "rgba(10, 138, 240)",
                                    "&:hover": {
                                        backgroundColor: darken(
                                            "rgba(10, 138, 240)",
                                            0.3
                                        ),
                                    },
                                    cursor: "pointer",
                                },
                                "& .commbank": {
                                    backgroundColor: "rgba(240, 205, 10)",
                                    "&:hover": {
                                        backgroundColor: darken(
                                            "rgba(240, 205, 10)",
                                            0.3
                                        ),
                                    },
                                    cursor: "pointer",
                                },
                                "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                                    {
                                        outline: "none !important",
                                    },
                                "& .MuiDataGrid-columnHeaders": {
                                    color: theme.palette.primary.contrastText,
                                },
                                "& .MuiDataGrid-footerContainer": {
                                    borderTop: "none",
                                    color: theme.palette.primary.contrastText, // dosent work
                                },
                                "& .MuiDataGrid-cell": {
                                    color: "black",
                                },
                                height: "100%",
                            }}
                            onRowClick={handleGridClick}
                            rows={loading ? [] : gridTotals}
                            columns={gridHeaders}
                            autoPageSize
                            disableRowSelectionOnClick
                            getRowClassName={(params) => params.id}
                            loading={loading}
                        />
                    </Box>
                    <Box
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 1,
                            boxShadow: 14,
                            gridColumn: "span 6",
                            gridRow: "span 3",
                            outline: `1px solid ${theme.palette.primary.main}`,
                            transition: "outline 1s ease",
                            "&:hover": {
                                outline: `1px solid ${theme.palette.primary.contrastText}`,
                            },
                            "@media (max-width: 75em)": {
                                minHeight: "40vh",
                            },
                        }}
                    >
                        {loading ? (
                            <Skeleton
                                sx={{ bgcolor: "grey" }}
                                variant="rounded"
                                width={"100%"}
                                height={"100%"}
                            ></Skeleton>
                        ) : (
                            <Line
                                data={lineData}
                                updateMode="resize"
                                options={lineOptions}
                            />
                        )}
                    </Box>
                    <MessageModal
                        severity="error"
                        title="error"
                        open={error ? true : false}
                        onClose={closeAlert}
                    >
                        {error}
                    </MessageModal>
                </>
            </Container>
        </>
    );
}
